module.exports = __webpack_public_path__ + "static/img/13062B_3_C_20200428_LC.20a8ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13062B_3_C_20200428_LC.png
// module id = Z8sN
// module chunks = 0